import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import React from 'react';
import { motion } from "framer-motion";
import { animationProps } from '../props/props';
import ReactGA from "react-ga4";

interface ResumeProps {
  className?: string;
}

const handleLinkClick = (label: string) => {
  ReactGA.event({
    category: "Link",
    action: "Click",
    label: label, 
  });
};

const pdfLink = "../pdf/Deimler_Resume_2025.pdf";

const Resume: React.FC<ResumeProps> = () => {
  return (
    <motion.div className="animated-wrapper" {...animationProps}>
      <div className="inner">
        <div className="row">
          <div className="col-sm mb-5 mb-sm-0">
            <h3>School</h3>
            <ul>
              <li><strong>Drexel University</strong></li>
              <li>BS Digital Media, 2009</li>
              <li>3.6 - Cum Laude</li>

              <li>
                <br />Download: <a href={pdfLink} onClick={() => handleLinkClick("Resume PDF Link")} target="blank" className="fa fa-file-pdf-o">
                  <FontAwesomeIcon icon={faFilePdf} />
                  <span className="sr-only">PDF</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-sm mb-5 mb-sm-0">
            <h3>Work</h3>
            <ul className="margined">
              <li><strong><a href="http://www.slalom.com" onClick={() => handleLinkClick("Slalom Link")} target="_blank">Slalom</a></strong><br />
                Sr. Consultant<br />
                2022 - Present</li>
              <li><strong><a href="http://www.exeloncorp.com" onClick={() => handleLinkClick("Exelon Link")} target="_blank">Exelon Corporation</a></strong><br />
                Sr. Front-End Developer<br />
                2020 - 2022</li>
              <li><strong><a href="https://www.prnewswire.com/news-releases/protiviti-acquires-r2i-to-expand-digital-services-301704697.html" onClick={() => handleLinkClick("R2integrated Link")} target="_blank">R2integrated</a></strong><br />
                Sr. Front-End Developer<br />
                2012 - 2020</li>
            </ul>
            <p></p>
            <p></p>
            <p></p>
          </div>
          <div className="col-sm">
            <h3>Skillset</h3>
            <ul>
              <li>HTML/CSS/JS</li>
              <li>Angular/React</li>
              <li>Bootstrap/Tailwind</li>
              <li>SASS/LESS</li>
              <li>AEM/Sitecore/Drupal/Wordpress/DNN</li>
              <li>Atlassian Suite</li>
              <li>Adobe Creative Suite</li>
              <li>Google Analytics</li>
              <li>Microsoft Azure</li>
              <li>Git</li>
            </ul>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Resume;